import { Wrapper, Search, Separator, Total, Showing, DefaultActions, GridToggles } from '@/components/Grid/components/header/Heading';
import { GridProvider, useBuildGrid, DefaultGrid } from '@Components/Grid';

import { useBuilderBlocksStore } from "../../store";

import useColumns from "./useColumns"
import useDefinitions from "./useDefinitions"
import useEvents from "./useEvents"
import useFilters from "./useFilters"

function BuilderBlocksGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  return <DefaultGrid
    heading={<Wrapper>
      <Search />
      <Separator />
      <GridToggles />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <DefaultActions add={null} />
    </Wrapper>}
  />
}

export default function BuilderBlocksGridLayout() {
  return <GridProvider store={useBuilderBlocksStore()}>
    <BuilderBlocksGrid />
  </GridProvider>
}
